export default [
  {
    items: 1,
    bonus: 0,
    premium: 25,
  },
  {
    items: 4,
    bonus: 1,
    premium: 100,
  },
  {
    items: 15,
    bonus: 5,
    premium: 375,
  },
  {
    items: 36,
    bonus: 14,
    premium: 900,
  },
];
